export const LEGACY = 'LEGACY';
export const NEW = 'NEW';
